import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AuthPage from "../pages/AuthPage";
import PlannerPage from "../pages/PlannerPage";
export default function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="app-loading">
        <span className="brand">
          forma<span>®</span>
        </span>
        <p>Opening your workspace…</p>
      </div>
    );
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={user ? <Navigate to="/" replace /> : <AuthPage />}
        />
        <Route
          path="/"
          element={user ? <PlannerPage /> : <Navigate to="/login" replace />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
